import networkAdapter from '../adapters/network';

export const sendSetPreferredDevice = ({ operationUuid, preferredDeviceName, userId }) => {
  const legacyOptions = {
    url: `/api/groot/v2/devices/${operationUuid}`,
    userId,
    method: 'PUT',
    redirectsToLoginOnAuthFail: false,
    body: JSON.stringify({
      'device-category': 'seeding',
      'device-name': preferredDeviceName
    })
  };
  
  return networkAdapter({
    legacyOptions
  });
};
